import { Button, Form, Menu, Segment } from 'semantic-ui-react';
import { connect } from 'react-redux';
import { useEffect } from 'react';
import * as showcaseActions from '../../../redux/actions/adSlotActions';
import PageContainer from '../../common/PageContainer';
import './Rep.scss';
import { TextField } from '../../common/FormFields';
import ListingCard from '../listings/ListingCard';
import * as selectors from '../../../redux/selectors';

const RepPage = ({ dispatch, match, current }) => {
  const id = match.params.id;

  //
  useEffect(() => {
    dispatch(showcaseActions.getAdSlotById(id));
  }, [id]);

  return (
    <PageContainer>
      <Menu borderless attached="top">
        <Menu.Item header>{current.name}</Menu.Item>

        <Menu.Menu position="right">
          <Menu.Item>
            <Button labelPosition="right" content="Save" icon="save" positive />
          </Menu.Item>
        </Menu.Menu>
      </Menu>

      <Segment attached>
        <Form size="mini" widths="equal">
          <Form.Group>
            <TextField label="Firm" />
            <TextField label="Listing type" />
            <TextField label="All listings URL" />
            <TextField label="Ga category" />
          </Form.Group>
          <Form.Group>
            <TextField label="Title override 1" />
            <TextField label="Title override 2" />
          </Form.Group>
          <Form.Group>
            <TextField label="Target path" />
            <TextField label="Target series" />
            <TextField label="Start date" />
            <TextField label="End date" />
          </Form.Group>
        </Form>
      </Segment>

      <div className="add-listing-controls">
        <Button content="Add listing" size="small" positive icon="plus" labelPosition="right" />
      </div>

      <div className="showcase-forms">
        {current.properties.map(p => (
          <ListingCard key={p.id} listing={p} />
        ))}
      </div>
    </PageContainer>
  );
};

const mapStateToProps = state => ({
  reps: selectors.reps.reps(state),
  current: selectors.reps.current(state),
});

export default connect(mapStateToProps)(RepPage);
